import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import axios from 'axios';
import { fetchEquipmentsService, fetchEquipmentsByIdService, fetchEquipmentsByIdWithServicesReplicateService, fetchEquipmentsExportService, fetchEquipmentsExportByPlaceService } from '../../services/equipments';
import { fetchEquipmentModelsService, fetchEquipmentModelsByIdService } from '../../services/equipmentModes';
import { fetchGroupsServices } from '../../services/groups';
import { fetchAreas } from '../../services/areas';
import { fetchPlacesLeafsService, fetchPlacesByIdService } from '../../services/places';
import { fetchCompaniesService } from '../../services/companies';
import { i18n } from '../../translate/i18n';
import api from '../../axios/api';
let CancelToken = axios.CancelToken;
let fetchEquipmentsByPlace_cancel;
let fetchEquipmentsByPlaceNoSearch_cancel;
let fetchEquipmentById_cancel;

export const setEquipmentsFilter = (page, limit, searchText, order, orderBy) => {
  return {
    type: actionTypes.SET_EQUIPMENTS_FILTER,
    equipmentsFilter: {
      page, limit, searchText, order, orderBy,
    }
  };
};

export const filterEquipmentGroups = (groups) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_GROUPS,
    groups,
  };
};

export const filterEquipmentGroupsRemove = (group) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_GROUPS_REMOVE,
    group,
  };
};

export const filterEquipmentAreas = (areas) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_AREAS,
    areas,
  };
};

export const filterEquipmentAreasRemove = (areas) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_AREAS_REMOVE,
    areas,
  };
};

export const filterEquipmentCompanies = (companies) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_COMPANIES,
    companies,
  };
};

export const filterEquipmentCompaniesRemove = (companies) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_COMPANIES_REMOVE,
    companies,
  };
};

export const filterEquipmentPlaces = (places) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_PLACES,
    places,
  };
};

export const filterEquipmentPlacesRemove = (place) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_PLACES_REMOVE,
    place,
  };
};

export const filterEquipmentModels = (models) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_MODELS,
    models,
  };
};

export const filterEquipmentModelsRemove = (model) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_MODELS_REMOVE,
    model,
  };
};

export const filterEquipmentStatus = (status) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_STATUS,
    status,
  };
};

export const filterDeletedEquipments = (deletedEquipments) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_DELETEDEQUIPMENTS,
    deletedEquipments,
  };
};

export const filterDeletedEquipmentsRemove = (deletedEquipments) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_DELETEDEQUIPMENTS_REMOVE,
    deletedEquipments,
  };
};

export const filterEquipmentClear = (model) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_CLEAR,
    model,
  };
};

export const setEquipmentsByPlaceFilter = (page, limit, searchText, order, orderBy) => {
  return {
    type: actionTypes.SET_EQUIPMENTS_BY_PLACE_FILTER,
    equipmentsFilter: {
      page, limit, searchText, order, orderBy,
    }
  };
};

export const filterEquipmentByPlaceGroups = (groups) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_BY_PLACE_GROUPS,
    groups,
  };
};

export const filterEquipmentByPlaceGroupsRemove = (group) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_BY_PLACE_GROUPS_REMOVE,
    group,
  };
};

export const filterEquipmentByPlaceAreas = (areas) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_BY_PLACE_AREAS,
    areas,
  };
};

export const filterEquipmentByPlaceAreasRemove = (areas) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_BY_PLACE_AREAS_REMOVE,
    areas,
  };
};

export const filterEquipmentByPlaceCompanies = (companies) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_BY_PLACE_COMPANIES,
    companies,
  };
};

export const filterEquipmentByPlaceCompaniesRemove = (companies) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_BY_PLACE_COMPANIES_REMOVE,
    companies,
  };
};

export const filterEquipmentByPlaceModels = (models) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_BY_PLACE_MODELS,
    models,
  };
};

export const filterEquipmentByPlaceModelsRemove = (model) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_BY_PLACE_MODELS_REMOVE,
    model,
  };
};

export const filterEquipmentByPlaceStatus = (status) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_BY_PLACE_STATUS,
    status,
  };
};

export const filterEquipmentByPlaceClear = (model) => {
  return {
    type: actionTypes.FILTER_EQUIPMENT_BY_PLACE_CLEAR,
    model,
  };
};

export const fetchEquipmentsSuccess = (equipments) => {
  return {
    type: actionTypes.FETCH_EQUIPMENTS_SUCCESS,
    equipments: equipments
  };
};

export const fetchEquipmentsByPlaceInfiniteScrollSuccess = (equipments) => {
  return {
    type: actionTypes.FETCH_EQUIPMENTS_BY_PLACE_INFINITE_SCROLL_SUCCESS,
    equipments: equipments
  };
};

export const fetchEquipmentsByPlaceSuccess = (equipments) => {
  return {
    type: actionTypes.FETCH_EQUIPMENTS_BY_PLACE_SUCCESS,
    equipments: equipments
  };
};

export const fetchEquipmentsByIdSuccess = (equipment) => {
  return {
    type: actionTypes.FETCH_EQUIPMENTS_BY_ID_SUCCESS,
    equipment: equipment
  };
}

export const requestEquipmentsFail = (error) => {
  return {
    type: actionTypes.REQUEST_EQUIPMENTS_FAIL,
    error: error
  };
};

export const requestEquipmentsStart = () => {
  return {
    type: actionTypes.REQUEST_EQUIPMENTS_START
  };
};

export const revertDeletedEquipmentFail = (error) => {
  return {
    type: actionTypes.REVERT_DELETED_EQUIPMENT_FAIL,
    error: error
  };
};

export const revertDeletedEquipmentStart = () => {
  return {
    type: actionTypes.REVERT_DELETED_EQUIPMENT_START
  };
};

export const revertDeletedEquipmentSuccess = (equipment) => {
  return {
    type: actionTypes.REVERT_DELETED_EQUIPMENT_SUCCESS,
    equipment: equipment
  }
}

export const requestEquipmentsByPlaceInfiniteScrollStart = () => {
  return {
    type: actionTypes.REQUEST_EQUIPMENTS_BY_PLACE_INFINITE_SCROLL_START
  };
};

export const deleteEquipmentsSuccess = (equipment) => {
  return {
    type: actionTypes.DELETE_EQUIPMENTS_SUCCESS,
    equipment: equipment
  }
}

export const checkDeleteDocumentEquipmentsSuccess = (checkDelete) => {
  return {
    type: actionTypes.CHECK_DELETE_EQUIPMENTS_SUCCESS,
    checkDelete: checkDelete
  }
}


export const updateEquipmentsSuccess = (equipment) => {
  return {
    type: actionTypes.UPDATE_EQUIPMENTS_SUCCESS,
    equipment: equipment
  }
}

export const inactivateEquipmentsSuccess = (body) => {
  return {
    type: actionTypes.INACTIVATE_EQUIPMENTS_SUCCESS,
    body,
  }
}

export const maintenanceEquipmentsSuccess = (body) => {
  return {
    type: actionTypes.MAINTENANCE_EQUIPMENTS_SUCCESS,
    body,
  }
}

export const deleteMultipleEquipmentsSuccess = () => {
  return {
    type: actionTypes.DELETE_MULTIPLE_EQUIPMENTS_SUCCESS,
  }
}

export const setManufacturingDate = (date) => {
  return {
    type: actionTypes.SET_EQUIPMENTS_MANUFACTURING_DATE,
    date: date
  };
};

export const postEquipmentsSuccess = (equipment) => {
  return {
    type: actionTypes.POST_EQUIPMENTS_SUCCESS,
    equipment: equipment
  }
}

export const setSearchTextEquipmentByPlace = (searchText) => {
  return {
    type: actionTypes.SET_SEARCH_TEXT_EQUIPMENT_BY_PLACE,
    searchText: searchText
  }
}

export const setDataChangedForceReload = (forceReload) => {
  return {
    type: actionTypes.SET_DATA_CHANGED_FORCE_RELOAD,
    forceReload: forceReload
  }
}

export const setExpirationDateServiceEquipmentsCreateFrom = (date, service, isValid = true) => {
  return {
    type: actionTypes.SET_EXPIRATION_DATE_SERVICE_EQUIPMENTS_CREATE_FORM,
    date,
    service,
    isValid,
  }
}

export const clearEquipmentsEquipmentModelsById = () => {
  return {
    type: actionTypes.CLEAR_EQUIPMENTS_EQUIPMENT_MODELS_BY_ID,
  }
}

export const fetchEquipments = (page, limit, search, order, orderBy, sites, filteredPlaces, filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus, filterDeletedEquipments) => {
  return dispatch => {
    dispatch(requestEquipmentsStart());
    dispatch(setEquipmentsFilter(page, limit, search, order, orderBy));
    fetchEquipmentsService(page, limit, search, order, orderBy, sites, filteredPlaces, filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus, filterDeletedEquipments)
      .then(res => {
        dispatch(fetchEquipmentsSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestEquipmentsFail(err));
      });
  };
};

export const fetchEquipmentsByPlace = (placeId, page, limit, search, order, orderBy, infiniteScroll = false, filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus) => {
  const filteredPlaces = [{ value: placeId}];
  const filteredSites = [];

  return dispatch => {
    if (!infiniteScroll) {
      dispatch(requestEquipmentsStart());
    } else {
      dispatch(requestEquipmentsByPlaceInfiniteScrollStart());
    }
    fetchEquipmentsService(page, limit, search, order, orderBy, filteredSites, filteredPlaces, filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus)
      .then(res => {
        if (!infiniteScroll) dispatch(fetchEquipmentsByPlaceSuccess(res.data))
        else dispatch(fetchEquipmentsByPlaceInfiniteScrollSuccess(res.data))
      })
      .catch(err => {
        dispatch(requestEquipmentsFail(err));
      });
  };
};

// export const fetchEquipmentsByPlace = (placeId, page, limit, search, order, orderBy, infiniteScroll = false) => {
//   fetchEquipmentsByPlace_cancel && fetchEquipmentsByPlace_cancel()

//   return dispatch => {
//     if (!infiniteScroll) {
//       dispatch(requestEquipmentsStart());
//     } else {
//       dispatch(requestEquipmentsByPlaceInfiniteScrollStart());
//     }
//     const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 2 ? 2 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
//     API.get('/equipments/place/' + placeId + queryParams, {
//       cancelToken: new CancelToken(function executor(c) {
//         fetchEquipmentsByPlace_cancel = c;
//       })
//     })
//       .then(res => {
//         if (!infiniteScroll) {
//           dispatch(fetchEquipmentsByPlaceSuccess(res.data));
//         } else {
//           dispatch(fetchEquipmentsByPlaceInfiniteScrollSuccess(res.data))
//         }
//       })
//       .catch(err => {
//         dispatch(requestEquipmentsFail(err));
//       });
//   };
// };

export const fetchEquipmentsByPlaceNoSearch = (equipName, placeId, page, limit, order, orderBy) => {
  fetchEquipmentsByPlaceNoSearch_cancel && fetchEquipmentsByPlaceNoSearch_cancel()

  return dispatch => {
    dispatch(requestEquipmentsStart());
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${equipName ? equipName : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    API.get('/equipments/place/' + placeId + '/nosearch' + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchEquipmentsByPlaceNoSearch_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchEquipmentsByPlaceSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestEquipmentsFail(err));
      });
  };
};

export const fetchEquipmentsById = (id) => {

  return dispatch => {
    dispatch(requestEquipmentsStart());
    fetchEquipmentsByIdService(id)
      .then(res => {
        dispatch(fetchEquipmentsByIdSuccess(res.data.equipment));
      })
      .catch(err => {
        // dispatch(requestEquipmentsFail(err));
      });
  };
};

export const fetchEquipmentsByIdWithServicesReplicate = (id) => {

  return dispatch => {
    dispatch(requestEquipmentsStart());
    fetchEquipmentsByIdWithServicesReplicateService(id)
      .then(res => {
        dispatch(fetchEquipmentsByIdSuccess(res.data));
      })
      .catch(err => {
        // dispatch(requestEquipmentsFail(err));
      });
  };
};

export const deleteEquipments = (index, page, limit, search, order, orderBy) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestEquipmentsStart());
      API.put('/equipments/' + index + '/delete')
        .then(res => {
          dispatch(deleteEquipmentsSuccess(res.data));
          toastr.success(i18n.t('deleteEquipments.toastr'), i18n.t('deleteEquipments.toastr1'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestEquipmentsFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })
  }
}

export const revertdeletedEquipments = (index, page, limit, search, order, orderBy) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(revertDeletedEquipmentStart());
      API.put('/equipments/' + index + '/revertdelete')
        .then(res => {
          dispatch(revertDeletedEquipmentSuccess(res.data));
          toastr.success(i18n.t('restoreEquipments.toastr'), i18n.t('restoreEquipments.toastr1'))
          resolve('success');
        })
        .catch(err => {
          dispatch(revertDeletedEquipmentFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })
  }
}

export const postEquipments = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestEquipmentsStart());
      API.post('/equipments', body)
        .then(res => {
          dispatch(postEquipmentsSuccess(res.data));
          toastr.success(i18n.t('postEquipmentsStr.toastr'), `${i18n.t('postEquipmentsStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestEquipmentsFail(err));
          if (err.response.data.message === "checkUniqueSerialNumber") {
            toastr.error(i18n.t('postEquipmentsStr.toastrError2'), i18n.t('postEquipmentsStr.serialNumberError'))
          } 
          else if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('postEquipmentsStr.toastrError'), i18n.t('postEquipmentsStr.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

export const getEquipmentsQRCodes = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestEquipmentsStart());
      API.post('/equipments', body)
        .then(res => {
          dispatch(postEquipmentsSuccess(res.data));
          toastr.success(i18n.t('getEquipmentsQRCodes.toastr'), `${i18n.t('getEquipmentsQRCodes.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestEquipmentsFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('getEquipmentsQRCodes.toastrError'), i18n.t('getEquipmentsQRCodes.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

export const updateEquipments = (index, body, message = '') => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestEquipmentsStart());
      API.put('/equipments/' + index, body)
        .then(res => {
          dispatch(updateEquipmentsSuccess(res.data));
          toastr.success(i18n.t('updateEquipmentsStr.toastr'), message);
          resolve('success');
        })
        .catch(err => {
          dispatch(requestEquipmentsFail(err));
          if (err.response.data.message === "checkUniqueSerialNumber") {
            toastr.error(i18n.t('updateEquipmentsStr.toastrError2'), i18n.t('updateEquipmentsStr.serialNumberError'))
          } 
          else if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateEquipmentsStr.toastrError'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

export const updateEquipmentFinance = (index, body, message = '') => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestEquipmentsStart());
      API.put('/equipments/' + index + '/finance/', body)
        .then(res => {
          dispatch(updateEquipmentsSuccess(res.data));
          toastr.success(i18n.t('updateEquipmentsStr.toastr'), message);
          resolve('success');
        })
        .catch(err => {
          dispatch(requestEquipmentsFail(err));
          if (err.response.data.message === "checkUniqueSerialNumber") {
            toastr.error(i18n.t('updateEquipmentsStr.toastrError2'), i18n.t('updateEquipmentsStr.serialNumberError'))
          } 
          else if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateEquipmentsStr.toastrError'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

export const inactivateEquipments = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      
			dispatch(requestEquipmentsStart());
      API.post('/equipments/inactivate', body)
        .then(() => {
          dispatch(inactivateEquipmentsSuccess(body));

          toastr.success(i18n.t('inactivateEquipments.toastr'),
          `(${body.ids.length}) ${body.sendForInactivate ? i18n.t('inactivateEquipments.toastr1') : i18n.t('inactivateEquipments.toastr2')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestEquipmentsFail(err));
					toastr.error('Erro', err.response.data.message)
          reject('error');
        });
    })
  }
}

export const maintenanceEquipments = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      
			dispatch(requestEquipmentsStart());
      API.post('/equipments/maintenance', body)
        .then(() => {
          dispatch(maintenanceEquipmentsSuccess(body));

          toastr.success(i18n.t('maintenanceEquipments.toastr'),
          `(${body.ids.length}) ${body.sendForMaintenance ? i18n.t('maintenanceEquipments.toastr1') : i18n.t('maintenanceEquipments.toastr2')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestEquipmentsFail(err));
					toastr.error('Erro', err.response.data.message)
          reject('error');
        });
    })
  }
}

export const deleteMultipleEquipments = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      
			dispatch(requestEquipmentsStart());
      API.post('/equipments/delete_multiple_equipments', body)
        .then(() => {
          dispatch(deleteMultipleEquipmentsSuccess());
          toastr.success(i18n.t('deleteEquipments.toastr'),
          `(${body.ids.length}) ${i18n.t('deleteEquipments.toastr1')}`);
          resolve('success');
        })
        .catch(err => {
          dispatch(requestEquipmentsFail(err));
					toastr.error('Erro', err.response.data.message)
          reject('error');
        });
    })
  }
}

export const checkDeleteEquipments = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestEquipmentsStart());
      API.get('/equipments/' + index + '/checkdelete')
        .then(res => {
          dispatch(checkDeleteDocumentEquipmentsSuccess(res.data));
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestEquipmentsFail(err));
          resolve('error');
        });
    })
  }
}

/// Other Collections

//Equipment Models

export const fetchEquipmentModelsSuccess = (equipmentModels) => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_EQUIPMENT_MODELS_SUCCESS,
    equipmentModels: equipmentModels
  };
};

export const requestEquipmentModelsFail = (error) => {
  return {
    type: actionTypes.EQUIPMENTS_REQUEST_EQUIPMENT_MODELS_FAIL,
    error: error
  };
};

export const requestEquipmentModelsStart = () => {
  return {
    type: actionTypes.EQUIPMENTS_REQUEST_EQUIPMENT_MODELS_START
  };
};

export const equipmentsFetchEquipmentModels = (page, limit, search, order, orderBy, documenttypeId) => {
  return dispatch => {
    dispatch(requestEquipmentModelsStart());
    fetchEquipmentModelsService(page, limit, search, order, orderBy, documenttypeId)
      .then(res => {
        dispatch(fetchEquipmentModelsSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestEquipmentModelsFail(err));
      });
  };
};

export const fetchEquipmentModelsByIdSuccess = (equipmentModel) => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_EQUIPMENT_MODELS_BY_ID_SUCCESS,
    equipmentModel: equipmentModel
  };
};

export const requestEquipmentModelsByIdFail = (error) => {
  return {
    type: actionTypes.EQUIPMENTS_REQUEST_EQUIPMENT_MODELS_BY_ID_FAIL,
    error: error
  };
};

export const requestEquipmentModelsByIdStart = () => {
  return {
    type: actionTypes.EQUIPMENTS_REQUEST_EQUIPMENT_MODELS_BY_ID_START
  };
};


export const equipmentsFetchEquipmentModelsById = (id) => {
  return dispatch => {
    dispatch(requestEquipmentModelsByIdStart());
    fetchEquipmentModelsByIdService(id)
      .then(res => {
        dispatch(fetchEquipmentModelsByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestEquipmentModelsByIdFail(err));
      });
  };
};

// Groups

export const fetchGroupsSuccess = (groups) => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_GROUPS_SUCCESS,
    groups: groups
  };
};

export const requestGroupsFail = (error) => {
  return {
    type: actionTypes.EQUIPMENTS_REQUEST_GROUPS_FAIL,
  };
};

export const requestGroupsStart = () => {
  return {
    type: actionTypes.EQUIPMENTS_REQUEST_GROUPS_START
  };
};

export const equipmentsFetchGroups = (page, limit, search, order, orderBy, documenttypeId) => {
  return dispatch => {
    dispatch(requestGroupsStart());
    fetchGroupsServices(page, limit, search, order, orderBy, documenttypeId)
      .then(res => {
        dispatch(fetchGroupsSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestGroupsFail(err));
      });
  };
};

// Areas

export const fetchAreasSuccess = (areas) => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_AREAS_SUCCESS,
    areas: areas
  };
};

export const requestAreasFail = (error) => {
  return {
    type: actionTypes.EQUIPMENTS_REQUEST_AREAS_FAIL,
  };
};

export const requestAreasStart = () => {
  return {
    type: actionTypes.EQUIPMENTS_REQUEST_AREAS_START
  };
};

export const equipmentsFetchAreas = (page, limit, search, order, orderBy, documenttypeId) => {
  return dispatch => {
    dispatch(requestAreasStart());
    fetchAreas(page, limit, search, order, orderBy, documenttypeId)
      .then(res => {
        dispatch(fetchAreasSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestAreasFail(err));
      });
  };
};

// Places

export const fetchPlacesLeafsSuccess = (placesLeafs) => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_PLACES_LEAFS_SUCCESS,
    placesLeafs: placesLeafs
  };
};

export const fetchPlacesByIdSuccess = (place) => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_PLACES_BY_ID_SUCCESS,
    place: place
  };
};

export const requestPlacesFail = (error) => {
  return {
    type: actionTypes.EQUIPMENTS_REQUEST_PLACES_FAIL,
    error: error
  };
};

export const requestPlacesStart = () => {
  return {
    type: actionTypes.EQUIPMENTS_REQUEST_PLACES_START
  };
};

export const equipmentsFetchPlacesLeafs = (sites) => {
  return dispatch => {
    dispatch(requestPlacesStart());
    fetchPlacesLeafsService(sites)
      .then(res => {
        dispatch(fetchPlacesLeafsSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestPlacesFail(err));
      });
  };
};


export const equipmentsFetchPlacesById = (id) => {
  return dispatch => {
    dispatch(requestPlacesStart());
    fetchPlacesByIdService(id)
      .then(res => {
        dispatch(fetchPlacesByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestPlacesFail(err));
      });
  };
};


// Companies

export const fetchCompaniesSuccess = (companies) => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_COMPANIES_SUCCESS,
    companies: companies
  };
};

export const requestCompaniesFail = (error) => {
  return {
    type: actionTypes.EQUIPMENTS_REQUEST_COMPANIES_FAIL,
  };
};

export const requestCompaniesStart = () => {
  return {
    type: actionTypes.EQUIPMENTS_REQUEST_COMPANIES_START
  };
};


export const equipmentsFetchCompanies = (page, limit, search, order, orderBy) => {
  return dispatch => {
    dispatch(requestCompaniesStart());
    fetchCompaniesService(page, limit, search, order, orderBy)
      .then(res => {
        dispatch(fetchCompaniesSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestCompaniesFail(err));
      });
  };
};

// Actions timeline

export const fetchActionsByEquipmentSuccess = (timelineActions) => {
  return {
    type: actionTypes.FETCH_ACTIONS_BY_EQUIPMENT_SUCCESS,
    timelineActions: timelineActions
  };
};

export const fetchMoreActionsByEquipmentSuccess = (timelineActions) => {
  return {
    type: actionTypes.FETCH_MORE_ACTIONS_BY_EQUIPMENT_SUCCESS,
    timelineActions: timelineActions
  };
};

export const fetchActionsByEquipmentFail = (error) => {
  return {
    type: actionTypes.FETCH_ACTIONS_BY_EQUIPMENT_FAIL,
  };
};

export const fetchMoreActionsByEquipmentStart = () => {
  return {
    type: actionTypes.FETCH_MORE_ACTIONS_BY_EQUIPMENT_START,
  };
};

export const fetchMoreActionsByEquipmentFail = (error) => {
  return {
    type: actionTypes.FETCH_MORE_ACTIONS_BY_EQUIPMENT_FAIL,
  };
};

export const fetchActionsByEquipmentStart = () => {
  return {
    type: actionTypes.FETCH_ACTIONS_BY_EQUIPMENT_START,
  };
};


export const fetchActionsByEquipment = (equipmentId, page, limit, filteredStatus, shouldFetchMoreData) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      if (shouldFetchMoreData) {
        dispatch(fetchMoreActionsByEquipmentStart());
      } else {
        dispatch(fetchActionsByEquipmentStart());
      }
      let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}`;
      queryParams += `${filteredStatus && filteredStatus.length > 0 ? `&status=${filteredStatus.join(',')}` : ''}`
      API.get(`/actions/equipment/${equipmentId}` + queryParams)
        .then(res => {
          if (shouldFetchMoreData) {
            dispatch(fetchMoreActionsByEquipmentSuccess(res.data));
          } else {
            dispatch(fetchActionsByEquipmentSuccess(res.data));
          }
          resolve(res.data);
        })
        .catch(err => {
          if (shouldFetchMoreData) {
            dispatch(fetchMoreActionsByEquipmentFail(err));
          } else {
            dispatch(fetchActionsByEquipmentFail(err));
          }
          resolve('error');
        });
    })
  }
};

// export
export const fetchEquipmentsExport = (search, order, orderBy, sites, filteredPlaces, filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus, emailLanguage) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      fetchEquipmentsExportService(search, order, orderBy, sites, filteredPlaces, filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus, emailLanguage)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          toastr.error('Erro', err)
          reject(err);
        });
    });
  };
};

export const fetchEquipmentsExportByPlace = (placeId, search, filteredModels, filteredGroups, filteredAreas, filteredCompanies, filteredStatus, emailLanguage) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      fetchEquipmentsExportByPlaceService(placeId, search, filteredModels, filteredGroups, filteredAreas,filteredCompanies, filteredStatus, emailLanguage)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          toastr.error('Erro', err)
          reject(err);
        });
    });
  };
};

// attachment files
export const fetchEquipmentByIdSuccess = (equipment) => {
  return {
    type: actionTypes.FETCH_EQUIPMENT_BY_ID_SUCCESS,
    equipment: equipment
  };
}

export const requestEquipmentFail = (error) => {
  return {
    type: actionTypes.REQUEST_EQUIPMENT_FAIL,
    error: error
  };
};

export const requestEquipmentStart = () => {
  return {
    type: actionTypes.REQUEST_EQUIPMENT_START
  };
};

export const fetchEquipmentAttachmentFileByIdSuccess = (attachments) => {
  return {
    type: actionTypes.FETCH_EQUIPMENT_ATTACHMENTFILE_BY_ID_SUCCESS,
    attachments,
  };
}

export const requestEquipmentAttachmentFileDocumentStart = () => {
  return {
    type: actionTypes.REQUEST_EQUIPMENT_ATTACHMENTFILE_DOCUMENT_START
  };
};

export const requestEquipmentAttachmentFileDocumentFail = (error) => {
  return {
    type: actionTypes.REQUEST_EQUIPMENT_ATTACHMENTFILE_DOCUMENT_FAIL,
    error: error
  };
};

export const fetchEquipmentById = (id) => {
  fetchEquipmentById_cancel && fetchEquipmentById_cancel()

  return dispatch => {
    dispatch(requestEquipmentStart());
    API.get('/equipments/' + id, {
      cancelToken: new CancelToken(function executor(c) {
        fetchEquipmentById_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchEquipmentByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestEquipmentFail(err));
      });
  };
};

export const handleManageEquipmentAttachments = (index, body, handleType) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestEquipmentAttachmentFileDocumentStart());
      API.post('/equipments/' + index + '/adddocument', body)
        .then(res => {
          dispatch(fetchEquipmentAttachmentFileByIdSuccess(res.data));
          handleType === 'new' && toastr.success(i18n.t('handleAttachFile.toastrCreateTitle'), i18n.t('handleAttachFile.toastrCreateMessage'))
          handleType === 'edit' && toastr.success(i18n.t('handleAttachFile.toastrEditTitle'), i18n.t('handleAttachFile.toastrEditMessage'))
          handleType === 'delete' && toastr.success(i18n.t('handleAttachFile.toastrDeleteTitle'), i18n.t('handleAttachFile.toastrDeleteMessage'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestEquipmentAttachmentFileDocumentFail(err));
          handleType === 'new' && toastr.error(i18n.t('handleAttachFile.toastrCreateErrorTitle'), i18n.t('handleAttachFile.toastrCreateErrorMessage'))
          handleType === 'edit' && toastr.error(i18n.t('handleAttachFile.toastrEditErrorTitle'),i18n.t('handleAttachFile.toastrEditErrorMessage'))
          handleType === 'delete' && toastr.error(i18n.t('handleAttachFile.toastrDeleteErrorTitle'),i18n.t('handleAttachFile.toastrDeleteErrorMessage'))
          resolve('error');
        });
    })
  }
}

const fetchEquipmentTimelineStart = () => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_TIMELINE_START,
  }
}

const fetchEquipmentTimelineSuccess = (timeline) => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_TIMELINE_SUCCESS,
    timeline,
  }
}

const fetchEquipmentTimelineFail = () => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_TIMELINE_FAIL,
  }
}

export const fetchEquipmentsTimelineById = (equipmentId) => {

  return dispatch => {
    dispatch(fetchEquipmentTimelineStart());
    API.get(`/equipments/${equipmentId}/timeline`)
      .then(res => {
        dispatch(fetchEquipmentTimelineSuccess(res.data.timeline));
      })
      .catch(err => {
        dispatch(fetchEquipmentTimelineFail());
      });
  };
};

const fetchEquipmentServicesReplicatedZipStart = () => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_SERVICES_REPLICATED_ZIP_START,
  }
}

const fetchEquipmentServicesReplicatedZipSuccess = () => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_SERVICES_REPLICATED_ZIP_SUCCESS,
  }
}

const fetchEquipmentServicesReplicatedZipFail = () => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_SERVICES_REPLICATED_ZIP_FAIL,
  }
}


export const fetchEquipmentServicesReplicatedZip= (equipmentsIds, language) => {

  return dispatch => {
    toastr.info(i18n.t('toastrFileDownBtn.info1'), i18n.t('toastrFileDownBtn.info2'));
    dispatch(fetchEquipmentServicesReplicatedZipStart());
    API.post(`/reports/service_report_zip/?language=${language}`, { ids: equipmentsIds })
      .then(res => {
        window.open(res.data.url);
        dispatch(fetchEquipmentServicesReplicatedZipSuccess());
      })
      .catch(err => {
        dispatch(fetchEquipmentServicesReplicatedZipFail());
        toastr.error(i18n.t('toastrFileDownBtn.error1'), i18n.t('toastrFileDownBtn.error2'));
        console.error(err);
      });
  };
};

export const fetchEquipmentServicesReplicatedDataExport= (equipmentIds, dataExportType, language) => {

  const body = {
    type: dataExportType,
    metadata: {
      language: language,
      equipmentIds,
    }
  }

  return dispatch => {
    toastr.info(i18n.t('toastrFileDownBtn.info1'), i18n.t('toastrFileDownBtn.info2'));
    API.post(`/dataexports`, body)
      .then(res => {
        console.log('res', res);
        window.open('/data-export', '_blank');
      })
      .catch(err => {
        toastr.error(i18n.t('toastrFileDownBtn.error1'), i18n.t('toastrFileDownBtn.error2'));
        console.error(err);
      });
  };
};


const fetchEquipmentServicesSimplifiedStart = () => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_SERVICES_SIMPLIFIED_START,
  }
}

const fetchEquipmentServicesSimplifiedSuccess = () => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_SERVICES_SIMPLIFIED_SUCCESS,
  }
}

const fetchEquipmentServicesSimplifiedFail = () => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_SERVICES_SIMPLIFIED_FAIL,
  }
}

export const fetchEquipmentServicesSimplified= (equipmentId) => {

  return dispatch => {
    toastr.info(i18n.t('toastrFileDownBtn.info1'), i18n.t('toastrFileDownBtn.info2'));
    dispatch(fetchEquipmentServicesSimplifiedStart());
    API.get(`/reports/equipmentServicesReplicate/${equipmentId}`)
      .then(res => {
        window.open(res.data.url);
        dispatch(fetchEquipmentServicesSimplifiedSuccess());
      })
      .catch(err => {
        dispatch(fetchEquipmentServicesSimplifiedFail());
        toastr.error(i18n.t('toastrFileDownBtn.error1'), i18n.t('toastrFileDownBtn.error2'));
        console.error(err);
      });
  };
};


const fetchServiceDraftsStart = () => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_SERVICE_DRAFTS_START,
  }
}

const fetchServiceDraftsSuccess = (serviceDrafts) => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_SERVICE_DRAFTS_SUCCESS,
    serviceDrafts,
  }
}

const fetchServiceDraftsFail = () => {
  return {
    type: actionTypes.EQUIPMENTS_FETCH_SERVICE_DRAFTS_FAIL,
  }
}


export const equipmentFetchServiceDraftsByEquipment = (equipmentId, page, limit) => {
  const query = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&sort=-startedAt&equipment=${equipmentId}`;

  return (dispatch) => {
    dispatch(fetchServiceDraftsStart());
    api.get('/servicedrafts' + query)
      .then((res)=> {
        dispatch(fetchServiceDraftsSuccess(res.data.data));
      })
      .catch(err => {
        dispatch(fetchServiceDraftsFail());
      });
  }
}


const deleteDraftStart = (draftId) => {
  return {
    type: actionTypes.EQUIPMENTS_DELETE_SERVICE_DRAFT_START,
    payload: draftId,
  }
}

const deleteDraftSuccess = () => {
  return {
    type: actionTypes.EQUIPMENTS_DELETE_SERVICE_DRAFT_SUCCESS,
  }
}

const deleteDraftFail = () => {
  return {
    type: actionTypes.EQUIPMENTS_DELETE_SERVICE_DRAFT_FAIL,
  }
}

export const equipmentDeleteServiceDraft = (draftId, page, limit, equipmentId) => {
  return (dispatch) => {
    dispatch(deleteDraftStart(draftId));
    api.put(`/servicedrafts/${draftId}/delete`)
      .then((res)=> {
        dispatch(deleteDraftSuccess());
        toastr.success(i18n.t('createService.toastrSucessDeleteDraftTitle'), '')
        dispatch(equipmentFetchServiceDraftsByEquipment(equipmentId, page, limit));
      })
      .catch(err => {
        dispatch(deleteDraftFail());
        toastr.error('createService.toastrErrorDeleteDraftTitle', err.message);
      });
  }
}
